import { FieldType } from '@databases/model/field';
import { CollabCalculationTypes } from '@databases/model/views/view';

export const isNumericFieldType = (fieldType: FieldType): boolean => {
  return fieldType === FieldType.Number;
};

export const nonNumericCollabCalculationTypes = [
  CollabCalculationTypes.COUNT,
  CollabCalculationTypes.COUNT_UNIQUE,
  CollabCalculationTypes.COUNT_EMPTY,
  CollabCalculationTypes.PERCENT_EMPTY,
  CollabCalculationTypes.PERCENT_NOT_EMPTY,
];
